module.exports = __webpack_public_path__ + "img/avatar.b9d3525b.svg";